export default (context, inject) => {
  const currency = (number) => context.store.$i18n.n(number, number % 1 ? 'currency' : 'currencyRound');
  inject('currency', currency);
  context.$currency = currency;
};
